


<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        field: {
            type: Object,
            required: true
        },
        fieldModel: {
            type: Object,
            required: true
        },
        className: {
            type: String
        },
        errorAfterBlur: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        sizeXL: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            value: null,
            blured: false,
            touched: false,
            focused: false
        }
    },
    computed: {
        activeErrors: function() {
            if (this.field.validations && this.field.validations.length > 0) {
                const filtered = this.field.validations.filter(v => {
                    if(this.fieldModel.$error && this.fieldModel[v.name] === false) {
                        return v;
                    }
                    return false;
                });

                return filtered;
            }
            return [];
        },
        isActive: function() {
            return !!this.fieldModel.$dirty || (this.fieldModel.$model && this.fieldModel.$model !== "");
        },
        showError: function() {
            let showError = this.fieldModel.$error && this.blured;
            if (!this.errorAfterBlur || !this.touched) {
                showError = this.fieldModel.$error
            }

            return showError;
        }
    },
    methods: {
        change(e) {
            let value = e.target.value;
            if (value && this.trimModel) {
                value = value.trim();
            }

            this.fieldModel.$model = value;
            this.$emit('input', value);
            this.fieldModel.$touch();
            this.touched = true;

            if (this.fieldModel.$model === value && this.trimModel) {
                this.$forceUpdate();
            }

        },
        onBlur() {
            this.blured = true;
            this.focused = false;
        },
        onFocus() {
            this.focused = true;
        }
    },
    render: function (h) {
        let fieldClass = "validate materialize-textarea ";
        let labelClass = "textarea--bordered-label";

        if (this.isActive || this.focused) {
            labelClass += ' active';
        }

        if (this.bordered) {
            fieldClass += ' textarea--bordered';
        }

        if (this.showError && this.fieldModel.$dirty) {
            fieldClass += ' invalid';
        }

        if (this.sizeXL) {
            fieldClass += ' materialize-textarea--xl';
        }

        let dataType = this.field.dataType;

        if (!this.field.dataType || this.field.dataType === 'string') {
            dataType = 'text';
        }

        const wrapperClass = `input-field ${this.className}`;

        return (
            <div class={wrapperClass} >
                <textarea
                    ref="inputRef"
                    disabled={this.disabled}
                    id={this.field.atrName}
                    type={dataType}
                    class={fieldClass}
                    value={this.fieldModel.$model}
                    onFocus={this.onFocus}
                    onChange={this.change}
                    onInput={this.change}
                    onblur={this.onBlur}>
                </textarea>

                <label
                    class={labelClass}
                    for={this.field.atrName}>
                    {this.field.title}
                </label>

                {
                    (this.showError && this.fieldModel.required === false) &&
                    <span class="error-message-container">
                        <i class="icon-info"></i>
                        <span>{this.$t('components.forms.invalid_required')}</span>
                    </span>
                }

                {
                    (this.showError && this.fieldModel.minLength === false) &&
                    <span  class="error-message-container">
                        <i class="icon-info"></i>
                        <span>{this.$tc(`components.forms.invalid_too_short`, this.fieldModel.$params.minLength.min)}</span>
                    </span>
                }

                {
                    (this.showError && this.fieldModel.maxLength === false) &&
                    <span  class="error-message-container">
                        <i class="icon-info"></i>
                        <span>{this.$tc(`components.forms.invalid_too_long`, this.fieldModel.$params.maxLength.max)}</span>
                    </span>
                }

                {
                    (this.showError && this.fieldModel.regexValidator === false) &&
                    <span class="error-message-container">
                        <i class="icon-info"></i>
                        <span>{this.$t('components.forms.invalid_format')}</span>
                    </span>
                }


                {(this.showError) &&
                    this.activeErrors.map(item => {
                        return (
                            <span class="error-message-container">
                                <i class="icon-info"></i>
                                {item.createDynamicContent && item.createDynamicContent(h)}
                                {item.errorText &&
                                    <span>
                                        {item.errorText && item.errorText}
                                    </span>
                                }
                            </span>
                        );
                    })
                }

            </div>
        )
    }
}
</script>


<style>
/*
.textarea--bordered {
    padding: 1rem !important;
    border: 0.1rem solid #caccd6 !important;
    box-sizing: border-box !important;
}

.textarea--bordered-label {
    margin: 1rem !important;
}

.textarea--bordered-label.active {
    margin: 0 !important;
}

textarea.materialize-textarea--xl {
  min-height: 9.2rem !important;
}

.materialize-textarea--xl + label + .error-message-container span {
  top: 11.2rem !important;
}

.materialize-textarea--xl + label + .error-message-container i {
  top: 7.6rem !important;
    right: 1rem !important;
}

textarea.materialize-textarea.invalid, textarea.materialize-textarea.invalid:focus {
    border-color: #EC4B61 !important;
}
*/
</style>